<template>
  <div v-bind:class="{ 'active': isOpened  }">
    <button class="filter__back" v-on:click.prevent="setOpened()" v-if="isOpened">
      <i class="daterange__goback--icon"></i>
      {{ $lang.filters.back }}
    </button>
    <div class="filter__header">
      <button v-on:click.prevent="toggleOpened()" class="filter__header--button" v-bind:class="{ 'filter__header--button-active': isOpened  }">
        {{ $lang.global[name] }}
        <div class="filter__header--icon"><i></i></div>
      </button>
    </div>

    <div v-if="isOpened" class="filter__list facet">
      <div class="facet__header">
        <button v-on:click.prevent="toggleOpened()" class="facet__header--close">
          <i></i>
        </button>
      </div>
      <div class="facet__content">
        <div class="facet__content--header">
          <div class="facet__search">
            <input class="facet__search--input" type="text" v-bind:placeholder="$lang.filters.search.placeholder" v-model="searchFilter">
            <i class="facet__search--submit"></i>
          </div>
          <div class="facet__addons">
            <div class="facet__addons--selected facet__selected">
              <button class="facet__selected--button" v-on:click="selectAll()" v-bind:class="{ 'facet__selected--button-active': checkedFiltersTmp.length != filteredListTmp.length }">
                <span class="facet__selected--checkbox">
                  <i class="facet__selected--icon facet__selected--icon-select">
                    <svg viewBox="0 0 16 16" class="input-box-tick"><path fill="none" d="M1.7,7.8l3.8,3.4l9-8.8"></path></svg>
                  </i>
                </span>
                <span class="facet__selected--text">{{ $lang.filters.select_all }}</span>
              </button>
              <button class="facet__selected--button" v-on:click="unSelectAll()" v-bind:class="{ 'facet__selected--button-active': checkedFiltersTmp.length > 0 }">
                <span class="facet__selected--text">{{ $lang.filters.deselect_all }}</span>
              </button>

            </div>
            <div class="facet__addons--pagination" v-if="totalPagesNum > 1">
              <div class="facet__pagination">
                <button v-bind:class="[{'disabled': currentPage == 1}, 'facet__pagination--prev']" v-on:click="setPrevPage()"><i class="onp-chevron-left"></i></button>
                <input class="facet__pagination--input" v-bind:disabled="totalPagesNum == 1" min="1" v-bind:max="totalPagesNum" v-on:change="updateCurrentPage($event)" type="text" v-bind:placeholder="currentPage" v-bind:value="currentPage">
                <span class="facet__pagination--text">{{ $lang.pagination.from_pages }} <strong>{{ totalPagesNum }}</strong></span>
                <button v-bind:class="[{'disabled': currentPage == totalPagesNum}, 'facet__pagination--next']"  v-on:click="setNextPage()"><i class="onp-chevron-right"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="facet__content--list">
          <ul class="facet__list" v-if="filteredList.length">
            <li class="facet__list--item" v-for="subFilter in filteredList">
              <label class="facet__list--label">
                <span class="facet__list--checkbox"><checkbox v-bind:value="subFilter.name" v-model="checkedFiltersTmp"></checkbox></span>
                <span class="facet__list--name" v-if="name === 'language'"><check-lang-code v-bind:langCode="subFilter.name"></check-lang-code></span>
                <span class="facet__list--name" v-else>{{ subFilter.name }}</span>
                <span class="facet__list--count" v-bind:lang="$lang.language" v-thousand-number="subFilter.results">{{ subFilter.results }}</span>
              </label>
            </li>
          </ul>
          <div v-else class="facet__emptylist">{{ $lang.filters.emptylist }}</div>
        </div>
        <div class="facet__content--footer facet__submit">
          <button class="facet__submit--button" v-bind:disabled="activeSubmit" v-on:click="setFilters()" >
            {{ $lang.filters.submit }}
          </button>
        </div>
      </div>
    </div>

    <div class="filter__content" v-if="filterParam">
      <ul class="filter__params">
        <li class="filter__params--item filter__param" v-for="filter in filterParam.filters">
          <span class="filter__param--name" v-if="name === 'language'"><check-lang-code v-bind:langCode="filter"></check-lang-code></span>
          <span class="filter__param--name" v-else v-bind:title="filter">{{ filter }}</span>
          <button class="filter__param--close" v-on:click="deleteFilter(filter)"><i></i></button>
        </li>
      </ul>
      <div class="filter__content--bottom">
        <button v-if="filterParam.filters" class="filter__params--clear" v-on:click="resetFilters()">
          {{ $lang.filters.clear }}
        </button>
        <button v-if="filterParam.filters" class="filter__params--add" v-on:click.prevent="toggleOpened()">
          {{ $lang.filters.add }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as filterModule from '../../scripts/modules/filter'
import groupElements from '../../scripts/reusable/group-array-elements'
import checkLangCode from './../Global/CheckLangCode'

export default {
  name: 'filter',
  components: {
    'check-lang-code': checkLangCode
  },
  props: {
    name: {
      type: String
    },
    values: {
      type: Array
    }
  },
  data () {
    return {
      checkedFiltersTmp: [],
      searchFilter: '',
      currentPage: 1,
      perPage: 20
    }
  },
  methods: {
    setOpened: function() {
      // opens and closes subfilters dropdown
      return (!this.isOpened) ? this.$store.commit('SET_FILTER_BOX', this.name) : this.$store.commit('SET_FILTER_BOX', false)
    },
    toggleOpened: function() {
      this.setOpened()
      return this.$store.commit('SET_IS_FILTER_BOX', this.isOpened)
    },
    setFilters: function() {
      // sends array with selected subfilters and general filter name
      filterModule.setFilters(this.checkedFiltersTmp, this.name)
      // unselects all subfilters
      this.unSelectAll()
      // close the subfilters box
      this.setOpened()
    },
    resetFilters: function() {
      // unselects all subfilters
      this.unSelectAll()
      // sends array with selected subfilters and general filter name
      filterModule.setFilters(this.checkedFiltersTmp, this.name)
    },
    deleteFilter: function(value) {
      // sends array without clicked subfilters and general filter name
      filterModule.setFilters(this.checkedFiltersTmp.filter(item => item !== value), this.name)
    },
    selectAll: function() {
      let that = this

      this.unSelectAll()
      // push all filters to checked subfilters array
      this.filteredListTmp.forEach( function (value){
        that.checkedFiltersTmp.push(value.name)
      })
    },
    // clears checked subfilters array
    unSelectAll: function() {
      this.checkedFiltersTmp = []
    },
    // sets next page
    setNextPage: function() {
      if (this.currentPage < this.totalPagesNum) {
        this.currentPage += 1
      }
    },
    // sets prev page
    setPrevPage: function() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
      }
    },
    updateCurrentPage: function(event) {
      // value fromt input
      let newVal = parseInt(event.target.value)
      if (newVal <= this.totalPagesNum && newVal >= 1) {
        this.currentPage = newVal
      }
    }
  },
  beforeMount() {
    // check if filters are set in url and check checkboxes
    this.checkedFiltersTmp = typeof this.filterParam !== typeof undefined ? this.filterParam.filters : []
  },
  computed: {
    isOpened: {
      get: function() {
        return (this.$store.getters.GET_FILTER_BOX == this.name)
      },
      set: function() {
        return false
      }
    },
    newValues() {
      // groups subfilters so name and number of results will be displayed as one object
      return groupElements(this.values)
    },
    // filters subfilters list so we can search
    filteredListTmp() {
      let list = this.newValues.filter(subFilter => {
        let langCodeName = this.$lang.langCode[subFilter.name];
        let langFullName = (langCodeName) ? langCodeName : 'none';
        return (this.name == 'language') ? langFullName.toLowerCase().includes(this.searchFilter.toLowerCase()) : subFilter.name.toLowerCase().includes(this.searchFilter.toLowerCase())
      })
      // ichecks if current page number is bigger then total nubmer of pages in the new, filtered list
      if (Math.ceil(list.length / this.perPage) < this.currentPage) {
        this.currentPage = 1
      }
      return list
    },
    // show filters on current page
    filteredList() {
      return this.filteredListTmp.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage)
    },
    // gets filter settings from store that should be displayed in this component
    filterParam() {
      return this.$store.getters.GET_FILTER_PARAMS_BY_NAME(this.name)
    },
    // disable filters submit
    activeSubmit() {
      return (!this.$store.getters.GET_FILTER_PARAMS_BY_NAME(this.name)) ? (this.checkedFiltersTmp.length == 0) : false
    },
    // counts total number of pages
    totalPagesNum() {
      return this.filteredListTmp.length > 0 ? Math.ceil(this.filteredListTmp.length / this.perPage) : 1
    }
  },
  watch: {
    // update subfilters according to the response
    filterParam: function (val) {
      this.checkedFiltersTmp = typeof val !== typeof undefined ? val.filters : []
    }
  }
}
</script>



// WEBPACK FOOTER //
// SearchFilter.vue?1f26a292